export * from './enums.ts';
export * from './network.ts';
export * from './version.ts';
export * from './game.ts';
export * from './notifications.ts';
export * from './PatchNote.ts';
export { CONTINENT_CODES } from './region.ts';
export { SharedStrings } from './SharedStrings.ts';
export var AccessLevel = /*#__PURE__*/ function(AccessLevel) {
    AccessLevel[AccessLevel["Administrator"] = 0] = "Administrator";
    AccessLevel[AccessLevel["User"] = 1] = "User";
    // Guest = 2, // !Warning Old access level that was removed and should not be used again
    // Customer = 3, // !Warning Old access level that was removed and should not be used again
    AccessLevel[AccessLevel["Manager"] = 4] = "Manager";
    AccessLevel[AccessLevel["Moderator"] = 5] = "Moderator";
    return AccessLevel;
}({});
export const CHAT_MAXIMUM_CHARACTER_LIMIT = 200;
export var DeviceType = /*#__PURE__*/ function(DeviceType) {
    DeviceType[DeviceType["Unknown"] = 0] = "Unknown";
    DeviceType[DeviceType["Web"] = 1] = "Web";
    DeviceType[DeviceType["Discord"] = 2] = "Discord";
    DeviceType[DeviceType["AppleWeb"] = 3] = "AppleWeb";
    DeviceType[DeviceType["AppleApp"] = 4] = "AppleApp";
    DeviceType[DeviceType["AndroidWeb"] = 5] = "AndroidWeb";
    DeviceType[DeviceType["AndroidApp"] = 6] = "AndroidApp";
    DeviceType[DeviceType["MobileUnknown"] = 7] = "MobileUnknown";
    DeviceType[DeviceType["DiscordMobile"] = 8] = "DiscordMobile";
    return DeviceType;
}({});
export const MOBILE_APP_DEVICE_TYPES = [
    4,
    6
];
export const MOBILE_WEB_DEVICE_TYPES = [
    3,
    5
];
export const MOBILE_UNKNOWN_DEVICE_TYPES = [
    7
];
export const MOBILE_DEVICE_TYPES = [
    ...MOBILE_APP_DEVICE_TYPES,
    ...MOBILE_WEB_DEVICE_TYPES,
    ...MOBILE_UNKNOWN_DEVICE_TYPES,
    8
];
export const DISCORD_DEVICE_TYPES = [
    2,
    8
];
export var OnlineCountCategory = /*#__PURE__*/ function(OnlineCountCategory) {
    OnlineCountCategory[OnlineCountCategory["GamePlayer"] = 1] = "GamePlayer";
    OnlineCountCategory[OnlineCountCategory["GameSpectator"] = 2] = "GameSpectator";
    OnlineCountCategory[OnlineCountCategory["RoomPlayer"] = 3] = "RoomPlayer";
    OnlineCountCategory[OnlineCountCategory["LobbyUser"] = 4] = "LobbyUser";
    OnlineCountCategory[OnlineCountCategory["Socket"] = 5] = "Socket";
    return OnlineCountCategory;
}({});
export var ServerState = /*#__PURE__*/ function(ServerState) {
    ServerState[ServerState["Starting"] = 1] = "Starting";
    ServerState[ServerState["Running"] = 2] = "Running";
    ServerState[ServerState["Draining"] = 3] = "Draining";
    ServerState[ServerState["Stopping"] = 4] = "Stopping";
    return ServerState;
}({});
export class AbortError extends Error {
    constructor(){
        super('AbortError');
    }
}
export const COLONIST_SYSTEM_USER_ID = '9223372036854775807';
